module.exports = __webpack_public_path__ + "img/consultor-digital-mobile.3b2c6723.svg";